<template>
    <div class="notification-system">
        <v-snackbar v-model="mainStore.notification.display" :color="get_snackbar_color()" location="top"
            :timeout="mainStore.notification.timeout">
            {{ mainStore.notification.message }}
            <template v-slot:actions>
                <v-btn variant="text" @click="snackbar = false">
                    x
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
export default {
    name: 'NotificationSystem',
    data() {
        return {
        };
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        get_snackbar_color() {
            if (this.mainStore.notification.type === 'success') {
                return 'success';
            } else if (this.mainStore.notification.type === 'error') {
                return 'error';
            }
            else {
                return 'info';
            }
        }
    }
};
</script>

<style scoped></style>